// @core/api/endpoints/secret/generate_credentials.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GenerateCredentialsRequest,
  GenerateCredentialsResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Generate database credentials
 * Generates ephemeral database credentials using the specified role. Returns username, password, and a lease ID for renewal/revocation. Credentials are automatically revoked when the lease expires.
 */
export async function GenerateCredentials(
  engine_id: string,
  role_name: string,
  data: GenerateCredentialsRequest,
  options?: RequestOptions
): Promise<GenerateCredentialsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/database/creds/:role_name`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':role_name', encodeURIComponent(role_name));
  const requestOptions = options;
  return client.post<GenerateCredentialsResponse>(requestPath, data, requestOptions);
}
